// Read-only continent derivation from ISO-2 country code (display-only, no storage, no migration).
// 6-continent FR model. Central America & Caribbean grouped under "Amérique du Nord".
import { COUNTRIES } from "@/lib/countries";

export const CONTINENT_BY_ISO = {
  // Europe
  FR: "Europe", GB: "Europe", DE: "Europe", ES: "Europe", IT: "Europe", PT: "Europe",
  CH: "Europe", BE: "Europe", NL: "Europe", LU: "Europe", IE: "Europe", AT: "Europe",
  DK: "Europe", SE: "Europe", NO: "Europe", FI: "Europe", IS: "Europe", PL: "Europe",
  CZ: "Europe", HU: "Europe", GR: "Europe", HR: "Europe", RO: "Europe", BG: "Europe",
  RU: "Europe", UA: "Europe",
  // Asie
  TR: "Asie", AE: "Asie", SA: "Asie", QA: "Asie", KW: "Asie", BH: "Asie", OM: "Asie",
  JO: "Asie", LB: "Asie", IL: "Asie", IN: "Asie", CN: "Asie", JP: "Asie", KR: "Asie",
  SG: "Asie", MY: "Asie", TH: "Asie", ID: "Asie", VN: "Asie", PH: "Asie", HK: "Asie",
  TW: "Asie", LK: "Asie", MV: "Asie", NP: "Asie",
  // Afrique
  MA: "Afrique", TN: "Afrique", DZ: "Afrique", EG: "Afrique", ZA: "Afrique", KE: "Afrique",
  TZ: "Afrique", NA: "Afrique", BW: "Afrique", SN: "Afrique", NG: "Afrique", MU: "Afrique",
  SC: "Afrique",
  // Amérique du Nord (incl. Central America & Caribbean)
  US: "Amérique du Nord", CA: "Amérique du Nord", MX: "Amérique du Nord", CR: "Amérique du Nord",
  PA: "Amérique du Nord", DO: "Amérique du Nord", CU: "Amérique du Nord", JM: "Amérique du Nord",
  // Amérique du Sud
  BR: "Amérique du Sud", AR: "Amérique du Sud", CL: "Amérique du Sud", PE: "Amérique du Sud",
  CO: "Amérique du Sud", EC: "Amérique du Sud", UY: "Amérique du Sud",
  // Océanie
  AU: "Océanie", NZ: "Océanie", FJ: "Océanie",
};

export const continentForCode = (code) => (code ? CONTINENT_BY_ISO[code] || null : null);

// Resolve continent from a stored country NAME (region field stays untouched; this is derived only).
export const continentForCountryName = (name) => {
  if (!name) return null;
  const c = COUNTRIES.find((x) => x.name === name);
  return c ? continentForCode(c.code) : null;
};
